<template>
  <base-tooltip
    v-if="!hideTooltip"
    min-width="115px"
    :offset="[-5, 3]"
  >
    <base-thumbnail
      v-if="brokenThumbnail"
      :class="`activity__img ${(url ? 'activity__cursor':'')}`"
      class="broken-img"
      :src="defaultViewThumbnail"
      :[thumbnailSize]="true"
      @click="handler"
    />
    <base-thumbnail
      v-else-if="!hasThumbnail"
      :class="`activity__img ${(url ? 'activity__cursor':'')}`"
      :src="thumbnail || defaultViewThumbnail"
      :[thumbnailSize]="true"
      @click="handler"
    />
    <base-thumbnail
      v-else
      :class="`activity__img ${(url ? 'activity__cursor':'')}`"
      class="broken-img"
      :src="defaultViewThumbnail"
      :[thumbnailSize]="true"
      @click="handler"
    />
    <template slot="tooltip">
      <div
        v-if="!hideTooltip"
        class="activity__tooltip"
      >
        <slot name="tooltip">

          <div v-if="placeholder">
            <base-text
              class="name_activitybold"
            >
              {{ url|truncate(65) }}
            </base-text>
          </div>
          <div v-else>
            <base-text
              v-if="name"
              size="s"
              light
              class="name_activitybold"
            >
              {{ name }}
            </base-text>
            <base-text
              v-else-if="url"
              class="name_activitybold"
            >
              {{ url|truncate(65) }}
            </base-text>
            <base-text
              v-if="price"
              size="s"
              light
              class="name_activitybold"
            >
              {{ price }}
              <span
                v-if="showSize || size"
                class="name_activitybold"
              >
                Size {{ size }}
              </span>
            </base-text>
          </div>
          <hr v-if="showDivider">
          <template v-if="isLike">
            <base-text
              size="s"
              light
              class="viewed"
            >
              Liked in {{ likedLocation }}
            </base-text>
            <base-text
              size="s"
              light
            >
              {{ lastUpdate | nicedate('relative') }}
            </base-text>
          </template>
          <template v-else>
            <template v-if="lastUpdate">
              <base-text
                v-if="count >= 1"
                size="s"
                light
                class="viewed"
              >
                Viewed {{ count }} time{{ count > 1 ? 's' : '' }}
              </base-text>
              <base-text
                size="s"
                light
                class="viewed_activity"
              >
                <!-- ex.  Last Viewed Jan 1, 1970 -->
                {{ dateVerb }} {{ lastUpdate | nicedate('relative') }}
              </base-text>
            </template>
          </template>
        </slot>
      </div>
    </template>
  </base-tooltip>
  <div v-else>
    <base-thumbnail
      v-if="!hasThumbnail"
      :class="`activity__img ${(url ? 'activity__cursor':'')}`"
      :src="thumbnail"
      :[thumbnailSize]="true"
      @click="handler"
    />
    <base-icon
      v-else
      icon="clicked-link"
      @click="handler"
    />
  </div>
</template>

<script>
export default {
  name: 'Product',
  props: {
    pk: {
      type: Number,
      default: -1,
    },
    showSize: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: '',
    },
    price: {
      type: [Number, String],
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    lastUpdate: {
      type: String,
      default: '',
    },
    dateVerb: {
      type: String,
      default: 'Added',
    },
    thumbnail: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    clickHandler: {
      type: Function,
      required: false,
    },
    thumbnailSize: {
      type: String,
      default: 'medium', // xsmall | small | medium | large
    },
    count: {
      type: Number,
      default: 0,
    },
    isLike: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: Boolean,
      default: false,
    },
    likedLocation: {
      type: String,
      default: 'Album',
    },
    noTooltip: {
      type: Boolean,
      default: false,
    },
    defaultViewThumbnail: {
      type: String,
      default: `${window.location.origin}/img/icon-link.svg`,
    },
  },
  data() {
    return {
      counter: 0,
    };
  },
  computed: {
    /** Hide if noTooltip, or if it's a non-product link click */
    hideTooltip() {
      return this.noTooltip || this.isNonProductClick;
    },
    hasThumbnail() {
      return !this.thumbnail || this.thumbnail.length === 0;
    },
    isNonProductClick() {
      return !this.isLike && this.pk === -1 && (this.price ?? -1) < 0 && !this.hasThumbnail;
    },
    showDivider() {
      return this.isLike || this.lastUpdate;
    },
    brokenThumbnail() {
      return this.thumbnail === 'broken';
    },
    defaultThumbnail() {
      return this.isNonProductClick ? `${window.location.origin}/img/icon-link.svg` : `${window.location.origin}/img/blank-product.png`;
    },
  },
  methods: {
    handler() {
      this.$mixpanel.track('click', {
        account_id: this.$store.state.account.user.user.email,
        product_url: this.url,
      });

      if (this.clickHandler) {
        return this.clickHandler({ ...this });
      } else {
        return this.openInNewTab(this.url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.activity__img {
  margin: 0.3rem 0;
  display: inline-block;
}
.activity__tooltip {
  // background-color: red !important;
  padding: 18px;
  text-align: center;

  hr {
    margin: 8px;
    // padding:8px 0px ;
    // margin: 0.2rem 0;
    border-color: #5B5B5B !important;
  }
}
.no-tooltip {
  ::v-deep &.base-tooltip {
    .tooltip {
        background-color: red !important;
        color: blue;
    }
  }
}
.returned {
  color: #e9ad7d;
}
.cancelled {
  color: #e9ad7d;
}
.viewed {
  color: #E9AD7D;
}
.viewed_activity{
  font-family: 'SilkaLight';
  font-size: 12px;
  color: #FFFFFF;
}
.name_activitybold{
  font-family: 'SilkaMedium';
  font-size: 14px;
  color: #FFFFFF;
}
</style>
